import type { DriverListQuery, Page } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../components/EmptyState';
import { ListSearch } from '../../components/ListSearch';
import type { ListQueryControls } from '../../lib/use-list-query';
import type { DriverListItem } from './drivers.api';

interface DriversTableProps {
  page: Page<DriverListItem>;
  columns: TableColumnsType<DriverListItem>;
  list: ListQueryControls<DriverListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function DriversTable({ page, columns, list, isRefreshing }: DriversTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search name, phone or licence number" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingDrivers /> } : undefined}
        {...list.tableProps<DriverListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingDrivers() {
  return <EmptyState icon={SearchX} title="No matching drivers" description="No drivers match this search or these filters." />;
}
